import { boxProperties } from '../../../data/boxProperties';
import { principalStreamersNames } from '../../../Environment.svelte';
import { findExtra } from '../../../Util.svelte';
import {
    CONSTANTS,
    TRIPLEPLAY_CATEGORIES,
    RESIDENCIAL_CATEGORIES,
    NEGOCIOS_CATEGORIES,
} from './constant';

const getIsIncludedStreaming = (plan, checkedCombos) => {
    const { isNetflix, vel, nombreCode } = plan;

    return {
        IS_NETFLIX_ESTANDAR_INCLUDED: checkedCombos && vel > 100 && isNetflix,

        IS_NETFLIX_ADD_INCLUDED: checkedCombos && vel < 150 && isNetflix,

        IS_MAX_INCLUDED: !isNetflix && vel < 150 && checkedCombos,

        IS_MAX_ADD_INCLUDED:
            (!checkedCombos || (checkedCombos && isNetflix)) && vel > 80,

        IS_APPLE_TV_INCLUDED: vel >= 200,

        IS_LALIGA_INCLUDED: !['izzitv_light', 'izzitv_lightm'].includes(
            nombreCode
        ),
    };
};

const getStaticVel = (category, vel) => {
    const boxPropertiesByCategory = boxProperties.find(
        (offer) => offer.category === category
    );

    if (!boxPropertiesByCategory?.prices) return vel;

    return (
        boxPropertiesByCategory.prices.find((offer) => offer.vel === vel)
            ?.promoVel || vel
    );
};

const getMovilPlan = (plan, selectedPlanMovilId) => {
    if (!selectedPlanMovilId) return;
    let planById = plan.extrasMap.movil2_0.find(
        (item) => item.extra.extName === selectedPlanMovilId
    );
    let planSelected = {
        imei: '',
        plan: planById,
        portability: 'Y',
        title: planById.extra.title,
    };
    return planSelected;
};

const getDetailsByOffer = (category, nombreCode, movilExtName) => {
    const { CATEGORY_4PLAY, CATEGORY_TRIPLEPLAY_MOVIL, CATEGORY_MOVIL } =
        CONSTANTS;

    const boxPropertiesDetails = boxProperties.find(
        (offer) => offer.category === category
    );

    if (!boxPropertiesDetails) return [];

    const detailsByNombreCode =
        boxPropertiesDetails.details?.find(
            (plan) => plan.nombreCode === nombreCode
        )?.features || [];

    category = [CATEGORY_4PLAY, CATEGORY_TRIPLEPLAY_MOVIL].includes(category)
        ? CATEGORY_MOVIL
        : category;

    const detailsByMovilExtName =
        boxPropertiesDetails.details?.find(
            (plan) => plan.extName === movilExtName
        )?.features || [];

    return {
        category: category,
        details: [
            ...detailsByNombreCode,
            ...detailsByMovilExtName,
            ...(boxPropertiesDetails.sharedDetails || []),
        ],
    };
};

const getStreamingPrice = (plan, category) => {
    const netflixName = principalStreamersNames.at(1);
    const netflixAdd = principalStreamersNames.at(6);
    const hboName = principalStreamersNames.at(4);
    const { isNetflix, isHBO } = plan;
    let streamingCost = 0;

    const applyDiscount = (opcionesModular) => {
        opcionesModular.forEach((o) => {
            if (
                (RESIDENCIAL_CATEGORIES.has(category) && o.play == '2P') ||
                (TRIPLEPLAY_CATEGORIES.has(category) && o.play == '3P')
            ) {
                streamingCost -= Number(o?.monto);
            }
        });
    };

    if (isNetflix) {
        const includedStreaming = getIsIncludedStreaming(plan, true);
        const netflixExtra = findExtra(
            includedStreaming.IS_NETFLIX_ESTANDAR_INCLUDED
                ? netflixName
                : netflixAdd,
            plan
        ).extra;

        applyDiscount(netflixExtra.opcionesModular);
        streamingCost += Number(netflixExtra.promoCost);
    }

    if (isHBO) {
        const hboExtra = findExtra(hboName, plan).extra;
        applyDiscount(hboExtra.opcionesModular);
        streamingCost += Number(hboExtra.cost);
    }

    return streamingCost;
};

const calculateDescuentos = (opcionesModular = []) =>
    opcionesModular.reduce((total, o) => total + Number(o?.monto || 0), 0);

const calculateOriginalCost = (plan, movilCost, category, checkedCombos) => {
    const { cost, opcionesModular } = plan;
    let streamingCost = 0;

    const totalDiscounts = calculateDescuentos(opcionesModular);

    if (movilCost) {
        movilCost = movilCost / 2;
    }

    if (checkedCombos) {
        streamingCost = getStreamingPrice(plan, category);
    }

    return Number(cost) - totalDiscounts + movilCost + streamingCost;
};

const calculateDiscountCost = (plan, movilCost, category, checkedCombos) => {
    const { PORTABILITY_DISCOUNT } = CONSTANTS;
    const { cost, discountCost, promoCost, opcionesModular } = plan;
    let streamingCost = 0;

    const totalDiscounts =
        calculateDescuentos(opcionesModular) + PORTABILITY_DISCOUNT;

    if (movilCost) {
        movilCost = movilCost / 2;
        return cost - totalDiscounts + movilCost;
    }

    if (checkedCombos) {
        streamingCost = getStreamingPrice(plan, category);
    }

    if (NEGOCIOS_CATEGORIES.has(category)) {
        return promoCost - totalDiscounts + movilCost + streamingCost;
    }

    return discountCost - totalDiscounts + movilCost + streamingCost;
};

const getStreamingLogos = ({
    shouldShowViXPremium,
    shouldShowMaxAdd,
    shouldShowMax,
    shouldShowNetflixEstandarAnuncios,
    shouldShowNetflixEstandar,
    shouldShowLaLiga,
    shouldShowSkeelo,
    shouldShowAppleTv,
    shouldShowClipPlus,
}) => [
    {
        src: '/assets/img/logos/clip-plus-logo.svg',
        alt: 'Clip+ Logo',
        shouldShow: shouldShowClipPlus,
    },
    {
        src: '/assets/img/logos/vixpremium-vertical-colored-white-logo.svg',
        alt: 'ViX Premium Logo',
        shouldShow: shouldShowViXPremium,
    },
    {
        src: '/assets/img/logos/max-add-black-logo.svg',
        alt: 'Max con anuncios Logo',
        shouldShow: shouldShowMaxAdd,
    },
    {
        src: '/assets/img/logos/hbomax-alt-logo.svg',
        alt: 'Max',
        shouldShow: shouldShowMax,
    },
    {
        src: '/assets/img/logos/netflix-estandar-logo.svg',
        alt: 'Netflix Estandar Logo',
        shouldShow: shouldShowNetflixEstandar,
    },
    {
        src: '/assets/img/logos/netflix-estandar-anuncios-black.svg',
        alt: 'Netflix Estandar con anuncios Logo',
        shouldShow: shouldShowNetflixEstandarAnuncios,
    },
    {
        src: '/assets/img/logos/apple-tv-logo.svg',
        alt: 'Apple TV Logo',
        shouldShow: shouldShowAppleTv,
        variant: 'bigger-variant',
    },
    {
        src: '/assets/img/logos/laliga-logo.svg',
        alt: 'LaLiga Logo',
        shouldShow: shouldShowLaLiga,
        variant: 'bigger-variant',
    },
    {
        src: '/assets/img/logos/skeelo-logo.svg',
        alt: 'Skeelo Logo',
        shouldShow: shouldShowSkeelo,
    },
];

const formatTitle = (movilTitle) => {
    let regex = /^\d+$/;

    if (!movilTitle) {
        return '';
    }

    let titleFormatted = movilTitle
        .replace('izzi', '')
        .replace('móvil', '')
        .replace('12 meses', '')
        .replace('comparte tus datos', 'ilimitado')
        .replace('gb', 'GB')
        .trim();

    if (regex.test(titleFormatted)) {
        titleFormatted = `${titleFormatted} GB`;
    }

    return titleFormatted;
};

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.parent.postMessage({ event: 'scrollToTop' }, '*');
};

const getStockByBranch = (stores, id) => {
    if (id == '') return CURRENT_STOCK_UNSELECTED;
    const store = stores.filter((store) => store.warehouse === id);
    return store.length > 0 ? store[0].stock : null;
};

export {
    calculateDiscountCost,
    calculateOriginalCost,
    getMovilPlan,
    getDetailsByOffer,
    getIsIncludedStreaming,
    getStaticVel,
    getStreamingLogos,
    formatTitle,
    scrollToTop,
    getStockByBranch,
};
